export const stockTableHead: string[] = [
  'Image',
  'Product information',
  'Category',
  'Price',
  'Stock',
];
export const cartTableHead: string[] = [
  'Item',
  'Price',
  'Quantity',
  'Total Price',
  '',
];

export const rekapTableHead: string[] = ['Product', 'Price', 'Total Income'];
